<template>
    <div id="post-edit">

        <div class="mt-1">
            <button @click="volver" class="btn btn-sm btn-secondary">Volver</button>
        </div>

        <h1>{{title}}</h1>

        <div v-if="cargando">
            <h2>CARGANDO POST</h2>
        </div>
        
        <div v-if="!cargando">
            <div class="form-group">
                <label><b>Fecha</b></label>
                <input class="form-control" v-model="post.fecha" id="fecha" type="date"/>
            </div>

            <div class="form-group">
                <label><b>Titulo</b></label>
                <input class="form-control" v-model.trim="post.titulo" id="titulo" type="text"/>
            </div>

            <div class="form-group">
                <label><b>Descripción corta</b></label>
                <textarea class="form-control" v-model.trim="post.descripcionCorta"></textarea>
            </div>

            <div class="form-group">
                <label><b>Descripción completa</b></label>
                
                <quill-editor class="wpo-editor" id="wpoEditor"
                            v-model="post.descripcion"
                            :config="editorOption">
                </quill-editor>
            </div>

            <hr />

            <h4 class="text-xs-center">Fuentes</h4>

            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <input class="form-control" v-model.trim="fuente.titulo" id="titulo" type="text" placeholder="Titulo"/>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <input class="form-control" v-model.trim="fuente.link" id="titulo" type="text" placeholder="Enlace"/>
                    </div>
                </div>

                <div class="col-md-2">
                    <button class="btn btn-success" @click="agregarEnlace">Agregar</button>
                </div>
            </div>

            <div>
                <table class="table">
                    <tr v-for="(enlace, index) in post.fuentes">
                        <td>
                            <a target="_blank" :href="enlace.link">{{ enlace.titulo }}</a>
                        </td>
                        <td>
                            <button @click="borrarEnlace(index)" class="btn btn-sm btn-danger">X</button>
                        </td>
                    </tr>
                </ul>
            </div>

            <div class="row mt-3">
                <div class="col-sm-4 text-left">
                    <button v-if="!nuevo" class="btn btn-danger" @click="eliminar">Eliminar</button>
                </div>

                <div class="col-sm-4">
                    <button class="btn btn-primary btn-block" @click="guardar">Guardar</button>
                </div>

                <div class="col-sm-4">
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import moment from 'moment';
import { quillEditor } from 'vue-quill-editor'

import fireApp from '../services/fireConfig.js'

import { savePost, getPostById, eliminarPost } from '../services/blog/blog.service.js'

export default {
    name: 'post-edit',
    components: {
        quillEditor
    },
    data () {
        return {
            title: null,
            cargando: true,
            editorOption: {
            // something config
            },
            post: {
                id: null,
                fecha: new Date(),
                timestamp: 0,
                titulo: null,
                descripcion: null,
                descripcionCorta: null,
                fuentes: []
            },
            fuente: {
                titulo: null,
                link: null
            },
            nuevo: false,
            id: "",
       }
    },
    methods: {
        guardar () {
            var fecha = moment(this.post.fecha);

            //this.post.fecha = moment(this.post.fecha).format('DD/MM/YYYY');
            this.post.timestamp = moment(fecha).unix();
            // console.log(this.post.fecha);
            // console.log(this.post.timestamp);

            let result = savePost(this.post);

            if (result.estado == false) {
                this.$notie.alert(3, result.mensajes.join('<br />') , 4);
                return
            }

            this.$notie.alert(1, 'Actualizado correctamente.' , 2);
        },
        eliminar() {
            let result = eliminarPost(this.post);

            this.$notie.alert(3, result.mensajes.join('<br />') , 4);
        },

        agregarEnlace() {

            if (!this.fuente.titulo) {
                this.$notie.alert(3, 'Ingrese un titulo' , 4);
                return;
            }

            if (!this.fuente.link) {
                this.$notie.alert(3, 'Ingrese un link para la fuente' , 4);
                return;
            }

            this.post.fuentes.push({
                titulo: this.fuente.titulo,
                link: this.fuente.link,
            });

            this.fuente = {
                titulo: null,
                link: null
            };
        },

        borrarEnlace(index) {
            console.log(index);
            this.post.fuentes.splice(index, 1);
        },


        volver() {
            this.$router.push({ path: '/blog'});
        }
    },
    created () {
        let cmp = this;
        let id = this.$route.params.id;

        if (!this.$route.params.id) {
            this.cargando = false;
            this.nuevo = true;
            this.title = "Nuevo Post";
            cmp.post.fecha = moment().format('YYYY-MM-DD');
        } else  {
            this.title = "Modificar Post";
            getPostById(this.$route.params.id, function(p) {
                cmp.post.id = p.id;
                cmp.post.fecha = p.fecha;
                cmp.post.timestamp = p.timestamp;

                cmp.post.titulo = p.titulo;
                cmp.post.descripcionCorta = p.descripcionCorta;
                cmp.post.descripcion = p.descripcion;

                if (p.fuentes) {
                    cmp.post.fuentes = p.fuentes;
                }

                cmp.nuevo = false;
                cmp.id = id;
                cmp.cargando = false;

                //cmp.post.fecha = moment(cmp.post.fecha).format('YYYY-MM-DD');
            })
        }

    }
    
}


</script>

<style scoped>
    #post-edit {
        margin-bottom: 50px;
    }

    h1 {
        text-align: center;
    }

    #wpoEditor {
        height: 350px;
    }
</style>



// WEBPACK FOOTER //
// Post-Edit.vue?2212a5ba